/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createLaborActivity } from '../fn/labor-activities/create-labor-activity';
import { CreateLaborActivity$Params } from '../fn/labor-activities/create-labor-activity';
import { deleteLaborActivity } from '../fn/labor-activities/delete-labor-activity';
import { DeleteLaborActivity$Params } from '../fn/labor-activities/delete-labor-activity';
import { getLaborActivity } from '../fn/labor-activities/get-labor-activity';
import { GetLaborActivity$Params } from '../fn/labor-activities/get-labor-activity';
import { LaborActivityDto } from '../models/labor-activity-dto';
import { LaborActivityDtoPage } from '../models/labor-activity-dto-page';
import { listLaborActivities } from '../fn/labor-activities/list-labor-activities';
import { ListLaborActivities$Params } from '../fn/labor-activities/list-labor-activities';
import { updateLaborActivity } from '../fn/labor-activities/update-labor-activity';
import { UpdateLaborActivity$Params } from '../fn/labor-activities/update-labor-activity';

@Injectable({ providedIn: 'root' })
export class LaborActivitiesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listLaborActivities()` */
  static readonly ListLaborActivitiesPath = '/v0/laborActivities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listLaborActivities()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborActivities$Response(params?: ListLaborActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDtoPage>> {
    return listLaborActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listLaborActivities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborActivities(params?: ListLaborActivities$Params, context?: HttpContext): Observable<LaborActivityDtoPage> {
    return this.listLaborActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborActivityDtoPage>): LaborActivityDtoPage => r.body)
    );
  }

  /** Path part for operation `getLaborActivity()` */
  static readonly GetLaborActivityPath = '/v0/laborActivities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLaborActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborActivity$Response(params: GetLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
    return getLaborActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLaborActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborActivity(params: GetLaborActivity$Params, context?: HttpContext): Observable<LaborActivityDto> {
    return this.getLaborActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborActivityDto>): LaborActivityDto => r.body)
    );
  }

  /** Path part for operation `updateLaborActivity()` */
  static readonly UpdateLaborActivityPath = '/v0/laborActivities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLaborActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborActivity$Response(params: UpdateLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
    return updateLaborActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLaborActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborActivity(params: UpdateLaborActivity$Params, context?: HttpContext): Observable<LaborActivityDto> {
    return this.updateLaborActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborActivityDto>): LaborActivityDto => r.body)
    );
  }

  /** Path part for operation `createLaborActivity()` */
  static readonly CreateLaborActivityPath = '/v0/laborActivities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLaborActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborActivity$Response(params: CreateLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
    return createLaborActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLaborActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborActivity(params: CreateLaborActivity$Params, context?: HttpContext): Observable<LaborActivityDto> {
    return this.createLaborActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborActivityDto>): LaborActivityDto => r.body)
    );
  }

  /** Path part for operation `deleteLaborActivity()` */
  static readonly DeleteLaborActivityPath = '/v0/laborActivities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLaborActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborActivity$Response(params: DeleteLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLaborActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLaborActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborActivity(params: DeleteLaborActivity$Params, context?: HttpContext): Observable<void> {
    return this.deleteLaborActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
